import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    alert('Thank you for contacting us. We will get back to you shortly.');
  };

  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* Hero Section */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Contact Us</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Contact Us</Link></li>
          </ul>
        </div>
      </div>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          
          <div className="heading-box text-center mb-5">
            <span className="heading-subtitle wow fadeInUp animated animated">⭐ GET IN TOUCH</span>
            <h2 className="heading-title wow fadeInUp animated animated">We're Here to Help</h2>
            <p className="mt-3 text-muted">Have questions about your loan? Need assistance with repayment? Our team is ready to assist you.</p>
          </div>

          <div className="row g-4">
            
            {/* Left Side: Contact Information */}
            <div className="col-lg-5">
              <div className="contact-card">
                <h3 className="contact-card-title">Contact Information</h3>
                
                <div className="contact-info-item">
                  <div className="contact-icon-box">
                    <i className="flaticon-phone-call"></i>
                  </div>
                  <div>
                    <h5 className="contact-info-label">Call Us</h5>
                    <p className="mb-0 text-muted"></p>
                    <a href="tel:+919911998997" className="contact-link">+91 9911998997</a>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon-box">
                    <i className="flaticon-mail"></i>
                  </div>
                  <div>
                    <h5 className="contact-info-label">Email Us</h5>
                    <p className="mb-0 text-muted">For general queries & support</p>
                    <a href="mailto:info@wallstreetfinz.com" className="contact-link">info@wallstreetfinz.com</a>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon-box">
                    <i className="flaticon-location"></i>
                  </div>
                  <div>
                    <h5 className="contact-info-label">Visit Us</h5>
                    <p className="mb-0 text-muted">
                     A 304, I Thum Tower, Sector 62, Noida
                    </p>
                  </div>
                </div>

                {/* Decorative Element */}
                <div className="contact-watermark">
                  <i className="flaticon-customer-service"></i>
                </div>
              </div>
            </div>

            {/* Right Side: Contact Form */}
            <div className="col-lg-7">
              <div className="contact-card">
                <h3 className="contact-card-title">Send a Message</h3>
                
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group-col">
                        <label className="contact-label">Your Name</label>
                        <input 
                          type="text" 
                          name="name"
                          className="form-control form-control-contact" 
                          placeholder="Full Name"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="form-group-col">
                        <label className="contact-label">Phone Number</label>
                        <input 
                          type="tel" 
                          name="phone"
                          className="form-control form-control-contact" 
                          placeholder="Mobile Number"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="form-group-col">
                        <label className="contact-label">Email Address</label>
                        <input 
                          type="email" 
                          name="email"
                          className="form-control form-control-contact" 
                          placeholder="name@example.com"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="form-group-col">
                        <label className="contact-label">Subject</label>
                        <select 
                          name="subject"
                          className="form-control form-control-contact"
                          onChange={handleChange}
                        >
                          <option value="">Select Subject</option>
                          <option value="Loan Inquiry">Loan Inquiry</option>
                          <option value="Repayment Issue">Repayment Issue</option>
                          <option value="Document Submission">Document Submission</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-12 mb-4">
                      <div className="form-group-col">
                        <label className="contact-label">Message</label>
                        <textarea 
                          name="message"
                          className="form-control form-control-contact" 
                          rows="4" 
                          placeholder="How can we help you?"
                          required
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-12">
                      <button type="submit" className="btn btn-primary btn-contact-submit">
                        Send Message <i className="flaticon-next ms-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;